import { useState, useEffect } from 'react';

const heroSlides = [
  {
    id: 1,
    image: 'https://public.readdy.ai/ai/img_res/04bf887980b7c99341342252e45ed9b1.jpg',
    alt: 'Riyadh City Aerial View',
    destination: 'Saudi Arabia',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Breathtaking%20view%20of%20Istanbul%20skyline%20at%20sunset%20with%20Hagia%20Sophia%20and%20Blue%20Mosque%20silhouettes%2C%20golden%20light%20reflecting%20on%20Bosphorus%20strait%2C%20dramatic%20clouds%2C%20professional%20travel%20photography%2C%20cinematic%20composition%2C%20warm%20amber%20and%20orange%20tones%2C%20magical%20atmosphere&width=1920&height=1080&seq=hero-istanbul-002&orientation=landscape',
    alt: 'Istanbul Skyline',
    destination: 'Turkey',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20Dubai%20skyline%20at%20dusk%20with%20Burj%20Khalifa%20towering%20over%20the%20city%2C%20modern%20architecture%2C%20golden%20and%20purple%20sky%2C%20city%20lights%20beginning%20to%20glow%2C%20professional%20travel%20photography%2C%20cinematic%20wide%20angle%2C%20luxurious%20atmosphere%2C%20high%20quality&width=1920&height=1080&seq=hero-dubai-003&orientation=landscape',
    alt: 'Dubai Skyline',
    destination: 'UAE',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20view%20of%20Madinah%20Prophet%20Mosque%20at%20night%20with%20green%20dome%20illuminated%2C%20peaceful%20atmosphere%2C%20pilgrims%20in%20courtyard%2C%20stunning%20Islamic%20architecture%2C%20professional%20photography%2C%20warm%20lighting%2C%20spiritual%20and%20serene%20mood%2C%20high%20quality&width=1920&height=1080&seq=hero-madinah-004&orientation=landscape',
    alt: 'Madinah Prophet Mosque',
    destination: 'Saudi Arabia',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Spectacular%20Cappadocia%20landscape%20at%20sunrise%20with%20hot%20air%20balloons%20floating%20over%20fairy%20chimneys%20and%20rock%20formations%2C%20golden%20morning%20light%2C%20dramatic%20scenery%2C%20professional%20travel%20photography%2C%20cinematic%20composition%2C%20magical%20atmosphere%2C%20Turkey&width=1920&height=1080&seq=hero-cappadocia-005&orientation=landscape',
    alt: 'Cappadocia Turkey',
    destination: 'Turkey',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20Antalya%20resort%20coastline%20aerial%20view%20with%20turquoise%20Mediterranean%20sea%2C%20white%20sandy%20beaches%2C%20luxury%20hotels%20and%20palm%20trees%20along%20the%20shore%2C%20crystal%20clear%20water%2C%20stunning%20Turkish%20Riviera%2C%20golden%20sunlight%2C%20professional%20travel%20photography%2C%20cinematic%20wide%20angle%2C%20vibrant%20colors&width=1920&height=1080&seq=hero-antalya-006&orientation=landscape',
    alt: 'Antalya Resort Turkey',
    destination: 'Antalya, Turkey',
  },
  {
    id: 7,
    image: 'https://readdy.ai/api/search-image?query=Sharm%20el%20Sheikh%20Red%20Sea%20resort%20aerial%20view%20with%20stunning%20turquoise%20and%20deep%20blue%20water%2C%20coral%20reefs%20visible%20from%20above%2C%20luxury%20beach%20resorts%20along%20the%20coastline%2C%20dramatic%20desert%20mountains%20in%20background%2C%20clear%20sunny%20sky%2C%20Egypt%2C%20professional%20travel%20photography%2C%20cinematic%20composition&width=1920&height=1080&seq=hero-sharm-007&orientation=landscape',
    alt: 'Sharm el Sheikh Egypt',
    destination: 'Sharm el Sheikh, Egypt',
  },
  {
    id: 8,
    image: 'https://readdy.ai/api/search-image?query=Marrakesh%20Morocco%20aerial%20view%20at%20golden%20hour%20with%20iconic%20Koutoubia%20Mosque%20minaret%20rising%20above%20the%20ancient%20medina%20rooftops%2C%20warm%20terracotta%20and%20ochre%20colors%2C%20bustling%20city%2C%20Atlas%20Mountains%20in%20the%20distant%20background%2C%20dramatic%20warm%20light%2C%20professional%20travel%20photography%2C%20cinematic%20composition&width=1920&height=1080&seq=hero-marrakesh-008&orientation=landscape',
    alt: 'Marrakesh Morocco',
    destination: 'Marrakesh, Morocco',
  },
  {
    id: 9,
    image: 'https://readdy.ai/api/search-image?query=AlUla%20desert%20landscape%20Saudi%20Arabia%20with%20dramatic%20ancient%20sandstone%20rock%20formations%20and%20Hegra%20Nabataean%20tombs%20carved%20into%20rose-red%20cliffs%2C%20vast%20golden%20desert%20stretching%20to%20the%20horizon%2C%20warm%20sunset%20light%20casting%20long%20shadows%2C%20mystical%20atmosphere%2C%20professional%20travel%20photography%2C%20cinematic%20wide%20angle%2C%20breathtaking%20natural%20wonder&width=1920&height=1080&seq=hero-alula-009&orientation=landscape',
    alt: 'AlUla Desert Saudi Arabia',
    destination: 'AlUla, Saudi Arabia',
  },
  {
    id: 10,
    image: 'https://readdy.ai/api/search-image?query=Petra%20Jordan%20ancient%20Nabataean%20city%20aerial%20view%20with%20the%20iconic%20Treasury%20Al-Khazneh%20carved%20into%20rose-red%20sandstone%20cliffs%2C%20dramatic%20canyon%20landscape%2C%20warm%20golden%20light%20illuminating%20the%20ancient%20ruins%2C%20archaeological%20wonder%2C%20professional%20travel%20photography%2C%20cinematic%20composition%2C%20timeless%20beauty&width=1920&height=1080&seq=hero-petra-010&orientation=landscape',
    alt: 'Petra Jordan',
    destination: 'Petra, Jordan',
  },
];

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
        setIsTransitioning(false);
      }, 500);
    }, 15000);

    return () => clearInterval(interval);
  }, []);

  const goToSlide = (index: number) => {
    if (index === currentSlide) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentSlide(index);
      setIsTransitioning(false);
    }, 500);
  };

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Images */}
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 w-full h-full transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.alt}
            className={`w-full h-full object-cover object-top transition-transform duration-[15000ms] ease-linear ${
              index === currentSlide ? 'scale-110' : 'scale-100'
            }`}
          />
        </div>
      ))}
      
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/40"></div>

      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 flex flex-col justify-center">
        <div className="max-w-3xl">
          <div className="inline-block px-4 py-2 bg-[#C9A961]/20 backdrop-blur-sm border border-[#C9A961]/30 rounded-full mb-6">
            <span className="text-[#C9A961] text-sm font-medium">Trusted by European Families</span>
          </div>

          <h2 className={`text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight transition-all duration-500 ${isTransitioning ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'}`} style={{ fontFamily: 'Playfair Display, serif' }}>
            Why Choose Alwaz Travel London
          </h2>

          <p className="text-xl lg:text-2xl text-white/90 mb-4 font-light leading-relaxed">
            Personalised travel, guided with purpose.
          </p>

          <p className="text-lg text-white/80 mb-8 leading-relaxed max-w-2xl">
            Our mission is to shape every journey through expert advisory and thoughtful planning, ensuring your trip is not just booked — but carefully crafted.
          </p>

          <p className="text-base text-white/75 mb-10 leading-relaxed max-w-2xl">
            We curate hand-selected stays across Saudi Arabia, the Middle East, and Turkey, chosen for quality, cultural alignment, and family comfort. From first enquiry to final return, our advisors remain closely involved, managing every detail with precision.
          </p>

          <p className="text-base text-white/75 mb-12 leading-relaxed max-w-2xl">
            The result is a seamless, meaningful, and memorable travel experience — delivered with discretion, reliability, and care.
          </p>

          <div className="flex flex-wrap gap-4">
            <button 
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="px-8 py-4 bg-[#C9A961] text-white rounded-lg text-base font-semibold hover:bg-[#B89851] transition-all flex items-center gap-2 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Start Planning Your Journey
              <i className="ri-arrow-right-line"></i>
            </button>
            <a 
              href="#destinations"
              className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-lg text-base font-semibold hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer"
            >
              Explore Destinations
            </a>
          </div>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex items-center gap-3">
        {heroSlides.map((slide, index) => (
          <button
            key={slide.id}
            onClick={() => goToSlide(index)}
            className={`group flex items-center gap-2 transition-all cursor-pointer ${
              index === currentSlide ? 'opacity-100' : 'opacity-60 hover:opacity-100'
            }`}
          >
            <div className={`h-1.5 rounded-full transition-all duration-300 ${
              index === currentSlide ? 'w-8 bg-[#C9A961]' : 'w-3 bg-white/70 group-hover:bg-white'
            }`}></div>
          </button>
        ))}
      </div>

      {/* Current Destination Label */}
      <div className={`absolute bottom-8 right-8 z-20 transition-all duration-500 ${isTransitioning ? 'opacity-0 translate-x-4' : 'opacity-100 translate-x-0'}`}>
        <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
          <i className="ri-map-pin-line text-[#C9A961]"></i>
          <span className="text-white text-sm font-medium">{heroSlides[currentSlide].destination}</span>
        </div>
      </div>

      <div className="absolute bottom-8 left-8 text-white/5 text-8xl font-bold pointer-events-none" style={{ fontFamily: 'Arial, sans-serif' }}>
        ALWAZ
      </div>
    </section>
  );
}
